import axios, { AxiosRequestConfig } from 'axios';

import NetworkAxiosError from 'utils/helpers/network-axios-error';

import { getToken } from '../authProvider';

// import { BACKEND_URL } from '../constants';

const axiosInstance = axios.create({
  timeout: 50 * 1000, // 50s
});

// REQUEST
axiosInstance.interceptors.request.use(
  (request) => {
    // eslint-disable-next-line no-param-reassign
    request.headers.Authorization = `Bearer ${getToken()}`; // Ai says this is always up2date

    return request;
  },
  (error) => Promise.reject(error),
);

// RESPONSE
// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     logRed('AxiosError:', error);
//
//     return Promise.reject(new NetworkAxiosError(error));
//   },
// );

axiosInstance.interceptors.response.use((response) => {
  if (response.headers['content-type'] === 'text/html') {
    const url = response.config.url;
    const message = `404 - cannot find ${url} (api response content type is 'text/html')`;
    return Promise.reject({ message });
  }
  return response;
});

export function axiosRequest<T = unknown>(
  method: string, // this should be Method (from Axios)
  url: string,
  data: AxiosRequestConfig['data'] = {},
  options: AxiosRequestConfig = {},
) {
  const hasData = ['post', 'put', 'patch'].includes(method.toLowerCase());
  const settings = hasData ? options : data;
  const source = axios.CancelToken.source();
  // note sure if someone use this function for external urls so check if url is full url or not
  const extendedUrl =
    url.includes('http') || url.includes('https')
      ? url
      : `${global.clientConfig?.BackendUrl}/${url}`; //.replace('//', '/');
  const config: AxiosRequestConfig = Object.assign(
    {
      method,
      url: extendedUrl,
      data: hasData ? data : undefined,
      cancelToken: source.token,
    },
    settings,
  );

  return axiosInstance.request<T>(config);
}
